import { Stack, Typography } from "@mui/material";

import './style.css';


export const ClientData = ({ client }) => {

    const { name, tel, email, movil, cif, address } = !!client && client;

    return (
        <Stack mt='1rem' className="card" alignItems='center' justifyContent='space-around'>
            <Typography mb='1rem' variant="h5" color='primary' > Cliente </Typography>
            <Stack flexDirection='row' flexWrap='wrap' width='90%' justifyContent='space-around'>
                <Stack alignItems='center'>
                    <Typography variant="subtitle2"> <b> Empresa: </b>   {name}</Typography>
                    <Typography variant="subtitle2"> <b> Teléfono: </b>   {tel}</Typography>
                    <Typography variant="subtitle2"> <b> Móvil: </b>   {movil}</Typography>
                </Stack>
                <Stack alignItems='center'>
                    <Typography variant="subtitle2"> <b> Cif: </b>   {cif}</Typography>
                    <Typography variant="subtitle2"> <b> Email: </b>   {email}</Typography>
                    <Typography variant="subtitle2"> <b> Dirección: </b>   {address}</Typography>
                </Stack>
            </Stack>
        </Stack>
    )
}